export interface ReportFilter {
   name: string;
   relative?: boolean;
   value: any;
}

export class ReportFilter implements ReportFilter {
   constructor( f?: ReportFilter ) {
      this.name = f?.name;
      if ( f.relative ) { this.relative = f?.relative; }
      this.value = f?.value;
   }
}

export interface ReportSchema {
   name: string;
   header?: string;
   sort_ord?: number;
   sort_dir?: 'asc' | 'desc';
}

export class ReportSchema implements ReportSchema {
   constructor( s?: any ) {
      this.name = s?.name;
      if ( s?.header ) { this.header = s?.header; }
      if ( s?.sort_ord ) {
         this.sort_ord = s?.sort_ord;
         this.sort_dir = 'desc';
      }
      if ( s?.sort_dir && s?.sort_ord ) {
         this.sort_dir = s?.sort_dir;
      }
   }
}

export interface ReportColumn {
   name: string;

   header: string;

   type: string;
   width?: number;

   columns?: boolean;
   filters?: boolean;

   sort_order?: number;

   validator?: RegExp;
   action?: string;
}

export class ReportColumn implements ReportColumn {
   constructor( c?: ReportColumn ) {
      this.name = c?.name;
      this.header = c?.header;
      this.type = ( c?.type || '' ).toLowerCase();
      if ( c?.width ) { this.width = c?.width; }
      if ( c?.columns ) { this.columns = c?.columns; }
      if ( c?.filters ) { this.filters = c?.filters; }
      if ( c?.sort_order ) { this.sort_order = c?.sort_order; }
      if ( c?.validator ) { this.validator = c?.validator; }
      if ( c?.action ) { this.action = c?.action; }
   }
}

export interface Report {
   id: number;

   name: string;

   owned?: boolean;
   shared: boolean;
   version: number;
   last_updated?: string;
   doLineItems: boolean;

   filters: ReportFilter[];

   schema: ReportSchema[];
}

export class Report implements Report {
   constructor( r?: any ) {
      if ( r?.id ) { this.id = r?.id; }

      this.name = r?.name || '';

      this.owned = r?.owned || false;
      if ( r?.shared && typeof r.shared === 'string' ) {
         r.shared = r.shared === 'true';
      }
      this.shared = r?.shared || false;
      this.version = r?.version || 0.01;
      if ( r?.last_updated ) { this.last_updated = r?.last_updated; }
      this.doLineItems = r?.doLineItems ?? true;

      this.filters = ( r?.filters || [] ).map( f => new ReportFilter( f ));
      this.schema = ( r?.schema || [] ).map( s => new ReportSchema( s ));
   }
}
